/** Keep in sync with bot/counterStrikeReveal.js BOT_COUNTER_STRIKE_REVEAL_MS */
export const OPPONENT_COUNTER_STRIKE_REVEAL_MS = 2000;
